<template>
  <main id="create-client-page" class="page-container">
    <button type="button" class="back-btn" @click="goBack">
      <i class="fa-solid fa-arrow-left"></i> Indietro
    </button>
    <form
      class="create-client-form"
      @submit.prevent="onCreateClient"
      novalidate
    >
      <!-- RIGA 1 -->
      <div class="create-client-row row-1">
        <div class="field">
          <label for="client-name">Nome cliente *</label>
          <input
            id="client-name"
            type="text"
            v-model="formData.clientName"
            placeholder="inserisci il nome del cliente..."
            required
          />
        </div>

        <div class="field">
          <label for="fiscal-code">Codice fiscale *</label>
          <input
            id="fiscal-code"
            type="text"
            v-model="formData.taxCode"
            placeholder="inserisci il codice fiscale..."
            required
          />
        </div>
      </div>

      <!-- RIGA 2: telefono + recapito -->
      <div class="create-client-row row-2">
        <div class="field">
          <label for="phone">Telefono *</label>
          <input
            id="phone"
            type="text"
            v-model="formData.phoneNumber"
            placeholder="inserisci il numero di telefono..."
            required
          />
        </div>

        <div class="contact-right-group">
          <div class="field">
            <label for="email">Email *</label>
            <input
              id="email"
              type="email"
              v-model="formData.email"
              required
              placeholder="inserisci l'indirizzo email..."
            />
          </div>

          <div class="field">
            <label for="pec">PEC</label>
            <input
              id="pec"
              type="email"
              v-model="formData.pec"
              placeholder="inserisci l'indirizzo PEC..."
            />
          </div>
        </div>
      </div>

      <hr />

      <!-- RIGA 3: ragione sociale + p.iva -->
      <div class="create-client-row row-3">
        <div class="field">
          <label for="business-name">Ragione sociale</label>
          <input
            id="business-name"
            type="text"
            v-model="formData.companyName"
            placeholder="inserisci la ragione sociale..."
          />
        </div>

        <div class="field">
          <label for="vat-number">P.IVA</label>
          <input
            id="vat-number"
            type="text"
            v-model="formData.vatNumber"
            placeholder="inserisci la partita IVA..."
          />
        </div>
      </div>

      <!-- RIGA 4: codice univoco + sede legale -->
      <div class="create-client-row row-4">
        <div class="field">
          <label for="unique-code">Codice univoco</label>
          <input
            id="unique-code"
            type="text"
            v-model="formData.uniqueCode"
            placeholder="inserisci il codice univoco..."
          />
        </div>

        <!-- Sede legale (inserimento manuale) -->
        <div class="field">
          <label for="lh-address">Sede legale</label>
          <input
            id="lh-address"
            type="text"
            v-model="formData.legalHeadquarters.address"
            placeholder="Inserisci indirizzo completo…"
            autocomplete="off"
          />
        </div>
      </div>

      <hr />

      <div class="save-button-container">
        <button
          id="create-client-button"
          class="primary-btn"
          type="submit"
          :disabled="!canSave"
          :title="!canSave ? 'Compila i campi obbligatori' : 'Crea cliente'"
        >
          Salva
        </button>
      </div>
    </form>

    <VueFinalModal
      v-model="showBackModal"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="confirm-modal-content"
    >
      <template #default>
        <button
          class="modal__close icons-button"
          @click="showBackModal = false"
          title="Chiudi"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
        <h3 class="modal__title">Tornare indietro?</h3>
        <p class="modal__subtitle">Le modifiche non salvate andranno perse.</p>
        <div class="modal-actions">
          <button class="secondary-btn" @click="showBackModal = false">
            Annulla
          </button>
          <button class="primary-btn confirm-btn" @click="confirmGoBack">
            Conferma
          </button>
        </div>
      </template>
    </VueFinalModal>
  </main>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";
import { trackEvent, EVENTS } from "@/utilities/analytics";

export default {
  name: "CreateClientPage",
  beforeRouteLeave(to) {
    if (
      this.navigationConfirmed ||
      to.name === "login" ||
      !this.hasUnsavedChanges
    ) {
      this.navigationConfirmed = false;
      return true;
    }
    this.pendingNavigation = to;
    this.showBackModal = true;
    return false;
  },
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  data() {
    return {
      showBackModal: false,
      pendingNavigation: null,
      navigationConfirmed: false,

      formData: {
        clientName: "",
        taxCode: "",
        phoneNumber: "",
        uniqueCode: "",
        companyName: "",
        vatNumber: "",
        pec: "",
        email: "",
        legalHeadquarters: {
          name: "",
          address: "",
          placeId: "",
          latitude: "",
          longitude: "",
          link: "",
        },
      },
      errorMessage: "",
      successMessage: "",
    };
  },
  computed: {
    canSave() {
      const f = this.formData;
      return (
        !!(f.clientName || "").trim() &&
        !!(f.taxCode || "").trim() &&
        !!(f.phoneNumber || "").trim() &&
        !!(f.email || "").trim()
      );
    },
    // true se l'utente ha inserito almeno un dato nel form.
    hasUnsavedChanges() {
      const f = this.formData;
      const scalars = [
        f.clientName,
        f.taxCode,
        f.phoneNumber,
        f.uniqueCode,
        f.companyName,
        f.vatNumber,
        f.pec,
        f.email,
        f.legalHeadquarters?.address,
      ];
      return scalars.some((v) => !!(v || "").trim());
    },
  },
  methods: {
    goBack() {
      this.pendingNavigation = null;
      // Nessun dato inserito: torna indietro senza conferma.
      if (!this.hasUnsavedChanges) {
        this.navigationConfirmed = true;
        this.$router.back();
        return;
      }
      this.showBackModal = true;
    },
    // Guardia reload/chiusura tab nativa del browser: dialog nativo di
    // conferma solo se ci sono dati non salvati.
    handleBeforeUnload(e) {
      if (!this.hasUnsavedChanges) return;
      e.preventDefault();
      e.returnValue = "";
    },
    confirmGoBack() {
      this.navigationConfirmed = true;
      this.showBackModal = false;
      if (this.pendingNavigation) {
        this.$router.push(this.pendingNavigation);
      } else {
        this.$router.back();
      }
    },
    ...mapActions(["createClient"]),

    resetLH() {
      this.formData.legalHeadquarters = {
        name: "",
        address: "",
        placeId: "",
        latitude: "",
        longitude: "",
        link: "",
      };
    },

    // ---- Submit ----
    async onCreateClient() {
      try {
        this.successMessage = "";
        this.errorMessage = "";

        if (!this.canSave) {
          this.$toast.error("Compila i campi obbligatori.");
          return;
        }

        // payload: JSON diretto, niente stringify
        const payload = { ...this.formData };

        // Allineato a EditClientPage: non inviare la sede legale se l'indirizzo
        // è vuoto (evita che l'API riceva un oggetto vuoto → "[object Object]").
        if (!payload.legalHeadquarters?.address?.trim()) {
          delete payload.legalHeadquarters;
        }

        const response = await this.$store.dispatch("createClient", payload);

        if (response.status === 200 || response.status === 201) {
          // Solo l'esito dell'operazione: nessun dato del cliente.
          trackEvent(EVENTS.CUSTOMER_CREATED, {
            action: "create",
            kind: "client",
            outcome: "success",
          });

          this.$toast.success(
            response.data?.message || "Cliente creato con successo!"
          );

          // reset form
          this.formData = {
            clientName: "",
            taxCode: "",
            phoneNumber: "",
            uniqueCode: "",
            companyName: "",
            vatNumber: "",
            pec: "",
            email: "",
            legalHeadquarters: {
              name: "",
              address: "",
              placeId: "",
              latitude: "",
              longitude: "",
              link: "",
            },
          };
          this.resetLH();

          setTimeout(() => {
            this.navigationConfirmed = true;
            this.$router.push({ name: "customers" });
          }, 800);
        }
      } catch (error) {
        if (error.response?.status === 409) {
          this.$toast.error(
            error.response.data?.details ||
              "Conflitto nei dati, chiave univoca 'Ragione sociale' già presente."
          );
        } else {
          this.$toast.error(
            error.response?.data?.details ||
              error.response?.data?.error ||
              "Errore durante la creazione del cliente."
          );
        }
      }
    },
  },
};
</script>

<style src="@/css/CreateClientPage.css"></style>
